/*
 * Bootstrap Select directive
 * Version 1.0.0
 * Octave
 **/

(function () {
  'use strict';

  angular
    .module('directive.bootstrap-select', [])

    /* @ngInject */
    .directive('selectpicker', ["$timeout", function ($timeout) {
      return {
        restrict: 'A',
        scope: false,
        link: function (scope, element, attrs) {
          scope.$eval(attrs.ngModel + '="' + element.val() + '"');
          $timeout(function () {
            element.selectpicker({
              mobile: scope.device ? scope.device.mobile : false
            });
          });

          scope.$on('$destroy', function () {
            element.selectpicker('destroy');
          });
        }
      };
    }]);

})();
